import React from 'react';

const ProgressBar = ({ value = 0, max = 100, leftLabel, rightLabel }) => {
  const pct = max > 0 ? Math.min(100, Math.max(0, (Number(value) / Number(max)) * 100)) : 0;
  return (
    <div>
      <div className="progress">
        <div className="progress-fill" style={{ width: pct.toFixed(2) + '%' }} />
      </div>
      {(leftLabel || rightLabel) && (
        <div className="progress-labels">
          <span>{leftLabel}</span>
          <span>{rightLabel}</span>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
